import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Switch, Input, Button, Modal, Checkbox, Radio } from "antd";
import { Button as MatButton } from "@mui/material";

import { PlusCircleFilled, PlusCircleOutlined, SearchOutlined } from "@ant-design/icons";
import qs from "qs";
import AntTable from "../../components/CustomTable/AntTable";
import { MdRadioButtonUnchecked, MdOutlineContentCopy } from 'react-icons/md';
import { BsCheckCircle } from 'react-icons/bs';
import Wrapper, { useMatStyles } from "./style";
import banner from "../../assets/images/banner.png";
import WalletCard from "../../components/CustomCard/WalletCard";
import Check from "../../assets/images/check.svg";
import Blocked from "../../assets/images/blocked.svg";
import Exp from "../../assets/images/export.svg";
import { LeftArrow, RightArrow } from "./arrows";
import del from "../../assets/images/delete.svg";
import settings from "../../assets/images/settings.svg";
import CreateWallet from "./modal/createWallet";
import PerformTransaction from "./modal/performTransaction";
import ExportData from "./modal/exportData";
import FundWallet from "./modal/fundWallet";
import WayaOfficialSettings from "./modal/wayaOfficialSettings";
import { hideLoader, showLoader } from "../../utils/loader";
import { ProfileContext } from "../../store/context/ProfileContext";
import { customBaseUrl, httpDelete, httpGet, httpPost } from "../../store/http";
import Layout from "../../components/Layout";
import { currencyFormat, transformName } from "../../utils/helper";
import themeColor from "../../theme/color";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import AntDropdown from "../../components/CustomDropdown/AntDropdown";
import PerformTransactionExcel from "./modal/PerformTransactionExcel";
import PerformTransactionForms from "./modal/PerformTransactionForms";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import TextField from '@mui/material/TextField';
import PinModal from "../../components/Modal/Pin/PinModal";
import WalletForms from "./modal/createWalletForms";
import { Filter, Filter1Outlined, FilterList } from "@mui/icons-material";
import AccountStatement from "./modal/statement";
import moment from "moment";
import generatePDF from "../Transaction/AllTransaction/generatePDF";
import { CSVLink } from "react-csv";
import GenerateStatement from "../Transaction/AllTransaction/generateStatement";

const EmailStatus = () => {
  const roles = localStorage.getItem('roles')

  let navigate = useNavigate();
  const { profile } = useContext(ProfileContext);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showBalance, setShowBalance] = useState(false);
  const [showCreateWallet, setShowCreateWallet] = useState(false);
  const [showPerform, setShowPerform] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [showFundWallet, setShowFundWallet] = useState(false);
  const [walletList, setWalletList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [showSettings, setShowSettings] = useState(false);
  const [wayaTransactions, setWayaTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState({});
  const [totalTransaction, setTotalTransaction] = useState(0)
  const [isAdmin, setIsadmin] = useState(false)
  const [showCreateMultiWallet, setShowCreateMultiWallet] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [validateOTP, setValidateOTP] = useState('');
  const [checked, setChecked] = useState(true);
  const [searchField, setSearchField] = useState(false)
  const [showBulkExcelTransaction, setShowBulkExcelTransaction] =
    useState(false);
  const [showFormTransaction, setShowFormTransaction] = useState(false);
  const [search, setSearch] = useState({
    searchBy: "id",
    searchText: "",
  });
  const [filter, setFilter] = useState('')
  const [otp, setOtp] = useState('')
  const [pagination, setPagination] = useState({ current: 0, pageSize: 10 });
  const [totalTrans, setTotalTrans] = useState(0)
  const [totalDebitTrans, setTotalDebitTran] = useState(0)
  const [totalCreditTrans, setTotalCredTrans] = useState(0)
  const [walletId, setWalletId] = useState('');
  const [walletNo, setWalletNo] = useState(0);
  const [selectedAccountName, setSelectedAccountName] = useState('')
  const [showStatement, setShowStatement] = useState(false)
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDate, setFilteredDate] = useState([]);
  const [emailData, setEmailData] = useState([]);
  const [status, setStatus] = useState('SUCCESS');

  const styles = useMatStyles();
  const [cardList, setCardList] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [type, setType] = useState('failed')
  const handleDefaultAccount = async (acctNo) => {
    showLoader();
    const defaultWallet = {
      // newDefaultAcctNo: acctNo,
      newDefaultAcctNo: walletId,
      userId: profile?.userId,
    };
    if (walletId) {
      setWalletId(walletId);
    } else {
      setWalletId(acctNo);
    }
    const res = await httpPost(
      `${customBaseUrl.walletUrl}/api/v1/wallet/user/account/toggle`,
      defaultWallet
    );

    if (res.status) {
      getEmailStatus();
      Swal.fire(`Accouunt Number ${acctNo} is set to default`);
      hideLoader();
    } else {
      Swal.fire(res.message);
      hideLoader();
    }
  };

  const updateCurrentSlide = (index) => {
    setWalletNo(index);
  };

  const handleDeleteWallet = async (acctNo) => {
    showLoader();
    const res = await httpPost(
      `${customBaseUrl.walletUrl}/api/v1/wallet/account/closure`,
      {
        customerAccountNo: acctNo,
      }
    );
    if (res.status) {
      getEmailStatus();
      hideLoader();
      Swal.fire("Deleted!", res.message, "success");
    } else {
      hideLoader();
      Swal.fire(res.message);
    }
  };

  const CheckBox = ({ status }) => {
    return (
      <div style={{ color: '#828282' }} className="last_one">
        {' '}
        <span style={{ marginRight: 30, marginLeft: 10 }}>
          {status ? (
            <BsCheckCircle color="#ff6700" size={15} />
          ) : (
            <MdRadioButtonUnchecked size={15} />
          )}
        </span>
      </div>
    );
  };

  const handleDropDown = (type, item) => {
    if (type === "fund") {
      setShowFundWallet(true);
      setSelectedWallet(item.accountNo);
      setSelectedAccountName(item?.acct_name);
    }
    if (type === "delete") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: themeColor.primary,
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          handleDeleteWallet(item.accountNo);
        }
      });
    }

    if (type === "primary") {
      handleDefaultAccount(item.accountNo);
    }
    if (type === "block") {
      // handleOpenBlock(item.id);
    }
  };

  const handleDeleteUser = async () => {
    showLoader();
    const response = await httpDelete(
      `${customBaseUrl.authUrl}/api/v1/user/delete/${profile?.userId}`
    );

    hideLoader();
    const { status, message } = response.data;
    if (status === false) {
      return Swal.fire("error", message, "error");
    }
    Swal.fire(message);
  };


  const getEmailStatus = async (page, size) => {
    const pages = page ? page : pagination.current;
    const limit = size ? size : pagination.pageSize;
    const res = await httpGet(`${customBaseUrl.walletUrl}/api/v1/wallet/status/${status}?page=${pages}&size=${limit}`);

    if (res?.status) {
      setEmailData(res.data.updates);
      setTotalTransaction(res.data.totalElements);
    }

  };

  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
    await getEmailStatus(0, value);
  };

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    await getEmailStatus(newPage, pagination.pageSize);
  };

  const getRandomuserParams = (params) => ({
    size: params.pagination.pageSize ?? pagination.pageSize,
    page: params.pagination.current ?? pagination.current,
  });

  const getWayaTransaction = async (page, size) => {
    showLoader();
    const pages = page ? page : pagination.current;
    const limit = size ? size : pagination.pageSize;
    setLoading(true);
    /*const res = await httpGet(
        `${customBaseUrl.walletUrl}/api/v1/wallet/official/transaction?filter=${filter}&page=${pages}&size=${limit}`
      );*/
    const transacRes = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/find/transactions/${walletId}?page=${pages}&size=${limit}`
    );
    if (transacRes?.status) {
      hideLoader();
      setLoading(false);
      setTotalTransaction(transacRes.data.totalElements)
      setWayaTransactions(transacRes.data.content);
    }
    setLoading(false);
    hideLoader();
  };

  const handleValidate = async () => {
    showLoader();
    const res = await httpPost(
      `${customBaseUrl.authUrl}/api/v1/admin/authenticate-waya/otp-verify/${Number(otp)}`
    );
    if (res.status) {
      NotificationManager.success("Sucessful");
      setIsadmin(true)
      setIsModalVisible(false)
      hideLoader();

    } else {
      hideLoader();
      navigate("../dashboard");
      NotificationManager.error(res.error);
    }
  }

  const sendOTP = async () => {
    const res = await httpGet(
      `${customBaseUrl.authUrl}/api/v1/admin/authenticate-waya/otp-send`
    );
    if (res.status = true) {
      NotificationManager.success("OTP sent");
    }
  }
  const handleOtp = () => {
    if (!isAdmin) {
      setIsModalVisible(true);
      sendOTP()

    }
  }

  const getStat = async () => {
    const res = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/get-official-credit-count`
    );
    if (res.status) {
      setTotalTrans(res.data)
    }
    const res1 = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/get-official-debit-transaction-count`
    );
    if (res1.status) {
      setTotalDebitTran(res1.data)
    }
    const res2 = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/get-official-debit-credit-count`
    );
    if (res2.status) {
      setTotalCredTrans(res2.data)
    }
  }


  useEffect(() => {

    if (profile?.userId) {
      getEmailStatus();

    }
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps


  const handleReverse = async (row) => {
    showLoader();
    // return  alert(JSON.stringify(row))
    let data = {
      tranId: row.tranId,
      tranDate: row.tranDate,
      tranCrncy: "NGN",
    }
    // `${customBaseUrl.withdrawalUrl}/admin/withdrawal/reverseWithdrawalTransaction`,

    let response = await httpPost(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/reverse`,
      data
    )

    if (response.status) {
      hideLoader();
      Swal.fire('Success', response.message);

    } else {
      Swal.fire('Error', response.message);
      hideLoader();

    }
  };

  const handleChecked = () => {
    if (walletNo) {
      setChecked(true)
    }
  }

  const dropDownOptions = ["Reverse"];
  const handleDropdownAction = (item, row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, reverse it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleReverse(row);
      }
    });


    if (item === "View") viewTransactions(item);
  };

  const WalletDropDownOptions = ["Block Account"];
  const handleWalletDropdownAction = (item, row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be block this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, block it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // handleReverse(row);
      }
    });


    if (item === "View") viewTransactions(item);
  };
  const viewTransactions = () => {
    return ''
  }


  const columns = [
    {
      headerName: "Id",
      field: "id",
      sorter: true,
      width: 150,
      headerClassName: styles.tableHeader,

    },
  ];

  const performTransactionOptions = [
    "Single User",
    "Excel Upload",
    "Web Forms",
  ];
  const handlePerformTransactions = (item) => {
    // if(roles.indexOf('ROLE_ADMIN_OWNER')!==-1 ||roles.indexOf('ROLE_ADMIN_SUPER') !==-1){
    if (item === "Single User") setShowPerform(true);
    if (item === "Excel Upload") setShowBulkExcelTransaction(true);
    if (item === "Web Forms") setShowFormTransaction(true);
    /*}else{
      NotificationManager.error('Not authorized');
    }*/
  };

  const walletOptions = [
    "Single Wallet",
    "Multiple Wallet"
  ];
  const handleWalletAction = (item) => {
    if (item === "Single Wallet") setShowCreateWallet(true);
    if (item === "Multiple Wallet") setShowCreateMultiWallet(true);

  };
  const transactionOptions = [
    "Debit",
    "Credit"
  ];
  const handleTransactionOption = (item) => {
    if (item === "Debit") setFilter("D");
    if (item === "Credit") setFilter("C");

  };

  function clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj
  }

  const getTransaction = async (e) => {
    e.preventDefault();
    showLoader();
    const response = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction-list/${filteredData?.acctNum}?fromdate=${moment(filteredDate?.fromdate).format('YYYY-MM-DD')}&todate=${moment(filteredDate?.todate).format('YYYY-MM-DD')}`
    );

    const filter = clean(filteredData);

    if (response.status === true) {
      const filtered = response?.data?.transaction?.filter(e => {
        return Object.keys(filter).every(key => {
          return filter[key] === e[key];
        });
        //if( e?.tranCategory?.includes(filteredData?.tranCategory) && e?.partTranType?.includes(filteredData?.partTranType) ) return e

      });
      setTotalTransaction(filtered?.length)
      setWayaTransactions(filtered);
      //setTransactions(filtered);
      //setFiltered(response.data.content)
      //setMetaData(filtered?.length);
      NotificationManager.success(response?.message)

      hideLoader();
    } else {
      NotificationManager.error(response?.message)
      setWayaTransactions([]);

      hideLoader();
    }
  };
  let category = ['COMMISSION', 'TRANSFER', 'REVERSAL', 'WITHDRAW', 'FUNDING', 'AIRTIME_TOPUP', 'DATA_TOPUP', 'CABLE']
  const handleQuery = async (acctNo) => {
    showLoader();
    const res = await httpPost(
      `${customBaseUrl.walletUrl}/api/v1/wallet/process`,
      {

      }
    );
    if (res?.status === true) {
      hideLoader();
      Swal.fire("Done!", res?.message, "success");

    } else {
      hideLoader();
      Swal.fire(res?.message);
    }
  };

  return (
    <Wrapper>
      <div style={{ height: 400, width: "100%" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
          <h3 style={{ fontSize: 20, fontWeight: 600 }}>Email Status</h3>
          <div style={{ display: 'flex', gap: 10 }}>
            <select
              onChange={(e) => setStatus(e.target.value)}
              style={{
                padding: '5px 10px',
                borderRadius: 5,
                border: `1px solid ${themeColor.primary}`,
                backgroundColor: '#fff',
                color: themeColor.primary
              }}
            >
              <option value="SUCCESS">Success</option>
              <option value="FAILED">Failed</option>
              <option value="SKIPPED">Skipped</option>
            </select>
            <Button
              onClick={handleQuery}
              style={{
                backgroundColor: '#0f4c75',
                color: type === 'failed' ? '#fff' : themeColor.primary,
                borderRadius: 5,
                border: type === 'failed' ? 'none' : `1px solid ${themeColor.primary}`,
                padding: '5px 10px'
              }}
            >
              Query Emails
            </Button>
            {/* <Button
                    onClick={() => setType('failed')}
                    style={{
                        backgroundColor: type === 'failed' ? themeColor.primary : '#fff',
                        color: type === 'failed' ? '#fff' : themeColor.primary,
                        borderRadius: 5,
                        border: type === 'failed' ? 'none' : `1px solid ${themeColor.primary}`,
                        padding: '5px 10px'
                    }}
                >
                    Failed
                </Button>
                <Button
                    onClick={() => setType('skipped')}
                    style={{
                        backgroundColor: type === 'skipped' ? themeColor.primary : '#fff',
                        color: type === 'skipped' ? '#fff' : themeColor.primary,
                        borderRadius: 5,
                        border: type === 'skipped' ? 'none' : `1px solid ${themeColor.primary}`,
                        padding: '5px 10px'
                    }}
                >
                    Skipped
                </Button>
                <MatButton

                    variant="contained" 
                    style={{marginRight:20}}
                    // onClick={()=>setShowStatement(true)}
                >
                    <img src={Exp} alt="export" />           
                    <CSVLink
                data={(type === 'skipped' ? [emailData?.skippedUserIds] : [emailData?.failedUserIds])?.map((item, index) => ({ id: index + 1, userId: item }))}
                style={{            
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    textDecoration:"none"
                }}
                filename={type === 'skipped' ? 'Skipped UserId.csv' : 'Failed UserId.csv'}
                onClick={(event, done) => {
                    //event.preventDefault();
                    // handleFilterOperation();
                    //done()           
                }}
                >
                DOWNLOAD 
                </CSVLink>
                </MatButton>  */}

          </div>
        </div>

        <div style={{ display: 'flex', gap: 20, marginBottom: 20 }}>
          <div style={{
            backgroundColor: '#f5f5f5',
            padding: '20px',
            borderRadius: '10px',
            textAlign: 'center',
            flex: 1
          }}>
            <h4 style={{ margin: 0 }}>TOTAL {status}</h4>
            <p style={{ fontSize: '24px', fontWeight: 'bold', margin: '10px 0' }}>
              {totalTransaction || 0}
            </p>
          </div>
          {/* <div style={{
                backgroundColor: '#f5f5f5',
                padding: '20px',
                borderRadius: '10px',
                textAlign: 'center',
                flex: 1
            }}>
                <h4 style={{ margin: 0 }}>Total Skipped Update</h4>
                <p style={{ fontSize: '24px', fontWeight: 'bold', margin: '10px 0' }}>
                    {emailData?.skippedUpdates || 0}
                </p>
            </div>
            <div style={{
                backgroundColor: '#f5f5f5',
                padding: '20px',
                borderRadius: '10px',
                textAlign: 'center',
                flex: 1
            }}>
                <h4 style={{ margin: 0 }}>Total Successful  Update</h4>
                <p style={{ fontSize: '24px', fontWeight: 'bold', margin: '10px 0' }}>
                    {emailData?.successfulUpdates || 0}
                </p>
            </div>
            <div style={{
                backgroundColor: '#f5f5f5',
                padding: '20px',
                borderRadius: '10px',
                textAlign: 'center',
                flex: 1
            }}>
                <h4 style={{ margin: 0 }}>Total Update</h4>
                <p style={{ fontSize: '24px', fontWeight: 'bold', margin: '10px 0' }}>
                    {emailData?.totalUsers || 0}
                </p>
            </div> */}
        </div>

        <DataGrid
          getRowId={(row) => row.userId}
          // rows={(status === 'FAILED' ? emailData?.map((item, index) => ({ id: index + 1, userId: item })) : emailData) || []}
          rows={emailData || []}
          columns={[
            // { field: "id", headerName: "S/N", width: 90 },
            { field: "userId", headerName: "UserId", width: 300 },
            { field: "newEmail", headerName: "New Email", width: 300 },
            { field: "oldEmail", headerName: "Old Email", width: 300 },
            {
              field: "emailChanged", headerName: "Email Changed", width: 300,

              renderCell: (row) => JSON.stringify(row.emailChanged)
            },

          ]}
          pageSize={pagination.pageSize}
          onPageSizeChange={(newPageSize) =>
            handleChangeRowsPerPage(newPageSize)
          }
          paginationMode="server"
          onPageChange={(newPage) => handleChangePage(newPage)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          components={{ Toolbar: GridToolbar }}
          rowCount={totalTransaction}
        />

      </div>


    </Wrapper>
  );
};
const onWheel = (apiObj, ev) => {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

  if (isThouchpad) {
    ev.stopPropagation();
    return;
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext();
  } else if (ev.deltaY > 0) {
    apiObj.scrollPrev();
  }
};
export default EmailStatus;
